import "./WorkIndividual.css";
import behance from "../../Images/Social/behance.png";
import arrow from "../../Images/Icons/arrow.png";
import { useState } from "react";
import blogImage from "../../Images/Blogs/blog.png";
import pintrest from "../../Images/Social/pintrest.png";
import authorbig from "../../Images/Brand/authorBig.png";
import { useNavigate } from "react-router-dom";
const WorkIndividual = ({ title, desc, top1, top2, academy1, academy2, academy3, academy4, makeHere, hello }) => {

    const [imageOption, setImageOption] = useState(1);
    const LinkTo = useNavigate();
    return (
        <>

            {hello ?
                <>
                    <div className="workIndividualSec">
                        <div className="titleWorkIndividual">
                            {title}
                        </div>
                        <div className="descWorkIndividual">
                            A refined look at the visual identities, interfaces, and marketing assets I’ve designed for brands locally and globally.
                        </div>
                        {makeHere ?
                            <>

                            </>
                            :
                            <>
                                <div className="workSocialIndividual">
                                    <div className="workSocialBox">
                                        <img src={top1} alt="" />
                                    </div>
                                    <div className="workSocialBox">
                                        <img src={top2} alt="" />
                                    </div>
                                    <div className="workSocialBox">
                                        <div onClick={() => LinkTo("https://www.behance.net/gallery/231843173/Scaleup-AcademyW")} className="workLink">
                                            <div className="textWork">
                                                <span>Behance</span>
                                                <span>Behance</span>
                                            </div>

                                            <div className="iconWork">
                                                <img src={behance} alt="" />
                                                <img src={arrow} alt="" />
                                            </div>
                                        </div>
                                        <div onClick={() => LinkTo("https://www.pinterest.com/search/pins/?q=scaleup%20academy&rs=typed")} className="workLink">
                                            <div className="textWork">
                                                <span>Pintrest</span>
                                                <span>Pintrest</span>
                                            </div>

                                            <div className="iconWork">
                                                <img src={pintrest} alt="" />
                                                <img src={arrow} alt="" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="imageContainerWork">
                                    {imageOption > 1 &&
                                        <div onClick={() => setImageOption(imageOption - 1)} className="scrollLeftWork">
                                            <div className="upWork"></div>
                                            <div className="downWork"></div>
                                            <div className="textWorkScroll">
                                                <span>Scroll</span>
                                                <span>prev</span>
                                            </div>
                                        </div>
                                    }

                                    {imageOption < 4 &&
                                        <div onClick={() => setImageOption(imageOption + 1)} className="scrollRightWork">
                                            <div className="upWork"></div>
                                            <div className="downWork"></div>
                                            <div className="textWorkScroll">
                                                <span>Scroll</span>
                                                <span>next</span>
                                            </div>
                                        </div>
                                    }

                                    <div className={`imagesHere condition${imageOption}Image`}>
                                        <div className="imageSingle">
                                            <img className="" src={academy1} alt="" />
                                        </div>
                                        <div className="imageSingle">
                                            <img className="" src={academy2} alt="" />
                                        </div>
                                        <div className="imageSingle">
                                            <img className="" src={academy3} alt="" />
                                        </div>
                                        <div className="imageSingle">
                                            <img className="" src={academy4} alt="" />
                                        </div>
                                    </div>
                                </div>
                            </>
                        }

                    </div>
                </>
                :
                <>
                    <div className="workIndividualSec">
                        <div className="titleWorkIndividual">
                            {title}
                        </div>
                        <div className="descWorkIndividual">
                            A refined look at the visual identities, interfaces, and marketing assets I’ve designed for brands locally and globally.
                        </div>
                        <div className="imageContainerWork">
                            {imageOption > 1 &&
                                <div onClick={() => setImageOption(imageOption - 1)} className="scrollLeftWork">
                                    <div className="upWork"></div>
                                    <div className="downWork"></div>
                                    <div className="textWorkScroll">
                                        <span>Scroll</span>
                                        <span>prev</span>
                                    </div>
                                </div>
                            }

                            {imageOption < 4 &&
                                <div onClick={() => setImageOption(imageOption + 1)} className="scrollRightWork">
                                    <div className="upWork"></div>
                                    <div className="downWork"></div>
                                    <div className="textWorkScroll">
                                        <span>Scroll</span>
                                        <span>next</span>
                                    </div>
                                </div>
                            }

                            <div className={`imagesHere condition${imageOption}Image`}>
                                <div className="imageSingle">
                                    <img className="" src={academy1} alt="" />
                                </div>
                                <div className="imageSingle">
                                    <img className="" src={academy2} alt="" />
                                </div>
                                <div className="imageSingle">
                                    <img className="" src={academy3} alt="" />
                                </div>
                                <div className="imageSingle">
                                    <img className="" src={academy4} alt="" />
                                </div>
                            </div>
                        </div>
                        <div className="workSocialIndividual">
                            <div className="workSocialBox">
                                <img src={top1} alt="" />
                            </div>
                            <div className="workSocialBox">
                                <img src={top2} alt="" />
                            </div>
                            <div className="workSocialBox">
                                <div onClick={() => LinkTo("https://www.behance.net/gallery/231843173/Scaleup-AcademyW")} className="workLink">
                                    <div className="textWork">
                                        <span>Behance</span>
                                        <span>Behance</span>
                                    </div>

                                    <div className="iconWork">
                                        <img src={behance} alt="" />
                                        <img src={arrow} alt="" />
                                    </div>
                                </div>
                                <div onClick={() => LinkTo("https://www.pinterest.com/search/pins/?q=scaleup%20academy&rs=typed")} className="workLink">
                                    <div className="textWork">
                                        <span>Pintrest</span>
                                        <span>Pintrest</span>
                                    </div>

                                    <div className="iconWork">
                                        <img src={pintrest} alt="" />
                                        <img src={arrow} alt="" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        

                </div>
        </>
            }
            
        </>
    )
}
export default WorkIndividual;